/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import moment from "moment";
import {Button, DatePicker, Input, Select, Modal, Icon} from "../../components";
import {Constants, Globals, axios} from "../../utils";
import CreateEditProduct from "../products/create_edit_product";

const round2 = (n) => Math.round((+n + Number.EPSILON) * 100) / 100;

const INITIAL_STATE = {
  payment_type: Constants.PAYMENT_TYPES.PAID,
  comments: "",
  method_id: "",
  credit_days: "",
  provider_id: "",
  payment_date: "",
  amount_payment: "",
  initial_payment: "",
  discount: "",
  iva: "",
  // NUEVOS CAMPOS (opcionales)
  bill_number: "",
  person_receiving: "",
  receiving_date: "", // guardamos el valor crudo del DatePicker, luego lo formateamos en submit
  // NUEVO: control para calcular IVA
  has_iva: false,
};

class CreateEditPurchase extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      form: INITIAL_STATE,
      client: null,
      modalAddProducts: false,
      modalCreateProduct: false,
      disabled_button: false,
      products: [],
      brands: [],
      categories: [],
      provider: null,
      dates: [],
      data: {
        conversion: {},
        methods: [],
        providers: [],
      },
      edit: false,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  abortController = new AbortController();

  componentDidMount = async () => {
    this.getProviders();
    this.getPaymentMethods();
    this.getBrands();
    this.getCategories();
    if (this.props.edit) this.edit();
    // Pre-carga desde ORDEN DE COMPRA (conversión)
    if (this.props.inherit && this.props.inherit.type === "purchase_order") {
      this.prefillFromPurchaseOrder();
    }
  };

  componentWillUnmount() {
    this.abortController.abort();
  }

  getProviders = async (page = 1) => {
    let param = {
      user_id: this.props.user.id,
      admin_id: this.props.user.admin_id || this.props.user.id,
    };

    axios
      .post("web/admin/purchases/providers?page=" + page, param)
      .then(async (res) => {
        if (res.data.providers) {
          await this.setState((state) => ({
            data: {
              ...state.data,
              providers: [...state.data.providers, ...res.data.providers.data],
            },
          }));
          if (res.data.providers.data.length === 30) {
            await this.getProviders(page + 1);
          }
        }
      })
      .catch((err) => {
        Globals.showError();
      })
      .then(() => {
        Globals.quitLoading();
      });
  };

  getPaymentMethods = async (page = 1) => {
    let param = {
      user_id: this.props.user.id,
      admin_id: this.props.user.admin_id || this.props.user.id,
    };

    axios
      .post("admin/purchases/methods?page=" + page, param)
      .then(async (res) => {
        if (res.data.methods) {
          await this.setState((state) => ({
            data: {
              ...state.data,
              methods: [...state.data.methods, ...res.data.methods],
              conversion: res.data.conversion,
            },
          }));
          if (res.data.methods.length === 30) {
            await this.getPaymentMethods(page + 1);
          }
        }
      })
      .catch((err) => {
        Globals.showError();
      })
      .then(() => {
        Globals.quitLoading();
      });
  };

  getBrands = () => {
    let param = {
      user_id: this.props.user.id,
    };
    axios
      .post("web/admin/brands?page=", param)
      .then(async (res) => {
        if (res.data) {
          await this.setState({
            brands: res.data.brands,
          });
        }
      })
      .catch((err) => {
        Globals.showError();
      });
  };

  getCategories = () => {
    const {user} = this.props;
    let param = {
      user_id: user.id,
    };
    axios
      .post("web/admin/categories?page=", param)
      .then(async (res) => {
        if (res.data.result) {
          await this.setState({
            categories: res.data.categories.data,
          });
        }
      })
      .catch((err) => {
        Globals.showError();
      })
      .then(() => {
        Globals.quitLoading();
      });
  };

  // Modo "editar compra" existente
  edit = async () => {
    const {element} = this.props.edit;

    let products_element = [];
    element.details.map((item) => {
      let product = [];
      if (item.product) {
        product = item.product;
        product.quantity = item.quantity;
        product.selected_price = item.price;
        products_element.push(product);
      }
    });

    await this.setState({
      form: {
        id: element.id,
        quote_id: element.id,
        client_id: element.client_id,
        comments: element.comments,
        expiration_date: moment(element.expiration_date).isValid()
          ? moment(element.expiration_date).toDate()
          : "",
      },
      products: products_element,
      edit: true,
    });
  };

  // Pre-cargar datos desde una ORDEN DE COMPRA (para convertir)
  prefillFromPurchaseOrder = async () => {
    const {element} = this.props.inherit || {};
    if (!element) return;

    const details = element.details || [];

    const products_element = details.map((item) => {
      const base = item.product
        ? {...item.product}
        : {
            id: item.product_id || item.id,
            name: item.name || "",
            code: item.code || "",
            type: item.type,
            stock: item.stock || 0,
            stock_warehouse: item.stock_warehouse,
            total_quantity: item.total_quantity,
            decimal_stock: item.decimal_stock || Constants.DECIMAL_STOCK.NO,
            exento: item.exento,
            iva: item.iva,
          };

      base.quantity = item.quantity;
      base.sale_price =
        item.sale_price != null ? item.sale_price : base.sale_price || 0;
      base.purchase_price =
        item.purchase_price != null
          ? item.purchase_price
          : base.purchase_price || 0;

      if (item.stock_warehouse !== undefined)
        base.stock_warehouse = item.stock_warehouse;
      if (item.total_quantity !== undefined)
        base.total_quantity = item.total_quantity;

      if (item.discount_percentage != null && item.discount_percentage > 0)
        base.discount = item.discount_percentage;

      if (item.size_id) base.size_id = item.size_id;
      if (item.color_id) base.color_id = item.color_id;

      if (base.exento == null && item.exento != null) base.exento = item.exento;
      if (base.iva == null && item.iva != null) base.iva = item.iva;

      return base;
    });

    // Si la orden tiene IVA total > 0, activamos has_iva por defecto
    const hasIvaFromOrder = (parseFloat(element.iva) || 0) > 0;

    await this.setState({
      form: {
        ...this.state.form,
        provider_id: element.provider_id || "",
        method_id: element.method_id || "",
        comments: element.comments || this.state.form.comments,
        discount:
          element.discount_percentage > 0
            ? element.discount_percentage
            : this.state.form.discount,
        has_iva: hasIvaFromOrder,
      },
      products: products_element,
      edit: false,
    });
  };

  handleChange = (emitter) => {
    const {name, value} = emitter.target;

    this.setState({
      form: {
        ...this.state.form,
        [name]: value,
      },
    });
  };

  // ---- ayuda: % IVA por producto (8 / 16 / 31) ----
  getIvaPercent = (product) => {
    switch (product?.iva) {
      case Constants.PRODUCT_IVA.OCHO:
        return 8;
      case Constants.PRODUCT_IVA.DIECISEIZ:
        return 16;
      case Constants.PRODUCT_IVA.TREINTAIUNO:
        return 31;
      default:
        return 0;
    }
  };

  getTotal = () => {
    let subtotal = this.state.products
      .map(this.getItemSubtotal)
      .reduce((a, b) => round2(a + b), 0);

    const gPct =
      this.state.form.discount !== "" && this.state.form.discount <= 100
        ? Number(this.state.form.discount)
        : 0;

    if (gPct > 0) {
      const gDesc = round2((subtotal * gPct) / 100);
      subtotal = round2(subtotal - gDesc);
    }

    return subtotal;
  };

  // Calcula el subtotal de un producto con:
  // 1) descuento por producto
  // 2) IVA por línea (solo si has_iva es true y el producto NO es exento)
  getItemSubtotal = (product, onlyprice = false) => {
    const qty = Number(product.quantity) || 0;
    const price = parseFloat(product.purchase_price) || 0;

    // base
    let base = round2(qty * price);

    // descuento por línea
    let pct =
      product.discount != null && product.discount <= 100
        ? Number(product.discount)
        : 0;
    let desc = round2((base * pct) / 100);
    let neto = round2(base - desc);

    if (onlyprice === true) return neto;

    // IVA por producto (si aplica)
    const exento =
      product.exento === Constants.PRODUCT_EXENTO.NO ? false : true;
    let iva = 0;
    if (this.state.form.has_iva && !exento) {
      const rate = this.getIvaPercent(product); // 8 / 16 / 31
      iva = round2((neto * rate) / 100);
    }

    // total de la línea
    return round2(neto + iva);
  };

  getAmountPayment = () => {
    return this.state.dates.length > 0
      ? ((this.getTotal() || 0) - (this.state.form.initial_payment || 0)) /
          this.state.dates.length
      : 0;
  };

  delete = (index) => {
    Globals.confirm("¿Desea eliminar el producto de la compra?", () => {
      let products = [...this.state.products];
      products.splice(index, 1);
      this.setState({products});
    });
  };

  changeProduct = (value, target, index, callback = () => {}) => {
    let products = Globals.copy(this.state.products);
    products[index][target] = value;

    if (target === "quantity") {
      let newQuantity = value;

      if (products[index]?.decimal_stock === Constants.DECIMAL_STOCK.NO) {
        newQuantity = newQuantity === "" ? newQuantity : parseInt(newQuantity);
        products[index][target] = newQuantity;
      } else {
        products[index][target] = newQuantity.replace(/,/g, ".");
      }
    }

    this.setState({products}, () => callback());
  };

  changeValue = async (value, target, index, callback = () => {}) => {
    let products = Globals.copy(this.state.products);
    products[index][target] = value;

    await this.setState(
      {
        products,
      },
      () => callback(),
    );
  };

  setPaymentType = (payment_type) => {
    this.setState({
      form: {
        ...this.state.form,
        payment_type,
      },
    });
  };

  toggleDate = (date) => {
    const exists = this.state.dates.includes(date);

    this.setState((state) => ({
      dates: exists
        ? state.dates.filter((x) => x !== date)
        : [...state.dates, date],
    }));
  };

  // 1. Reemplazar método choseProducts en CreateEditPurchase
  choseProducts = (products = []) => {
    const {products: oldProducts} = this.state;

    const nonAdded = products
      .filter((np) => {
        return !oldProducts.some((op) => {
          return np.type === Constants.PRODUCTS_TYPE.SIZE_COLOR
            ? np.id === op.id &&
                np.color_id === op.color_id &&
                np.size_id === op.size_id
            : op.id === np.id;
        });
      })
      .map((p) => ({
        ...p,
        quantity: p.quantity || 1,
        purchase_price: p.purchase_price ?? p.sale_price ?? 0,
        selected_price: p.purchase_price ?? p.sale_price ?? 0,
      }));

    this.setState({
      products: [...oldProducts, ...nonAdded],
    });
  };

  enableSubmit = () => {
    return this.setState({
      disabled_button: false,
    });
  };

  submit = async () => {
    if (
      this.state.products.some((product) => {
        return (
          product.type === Constants.PRODUCTS_TYPE.SIZE_COLOR &&
          !product.size_id &&
          !product.color_id
        );
      })
    ) {
      Globals.showError(
        "Por favor, ingrese el color/talla de los productos que lo requieran",
      );
      return false;
    }

    for (const product of this.state.products) {
      if (product.purchase_price == 0) {
        Globals.showError(
          `El precio de compra del producto ${product?.name} debe ser mayor a $0.00`,
        );
        return false;
      }

      if (product.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) {
        const existsMoreThanOne =
          this.state.products.filter(
            (prod) =>
              prod.product_id === product.product_id &&
              prod.color_id === product.color_id &&
              prod.size_id === product.size_id,
          ).length > 1;
        if (existsMoreThanOne) {
          const color = product.size_colors?.find(
            (_i) => _i.color_id === product.color_id,
          )?.color;
          const size = product.size_colors?.find(
            (_i) => _i.size_id === product.size_id,
          )?.size;
          Globals.showError(
            `Lo sentimos, el producto ${product?.name} (${[size?.name, color?.name].filter((i) => i != null).join(",")}) se encuentra más de una vez en la compra`,
          );
          return false;
        }
      }
    }

    for (const product of this.state.products) {
      if (product.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) {
        const size_color = product?.size_colors?.find((i) => {
          if (product.size_id && product.color_id) {
            return (
              i.size_id == product.size_id && i.color_id == product.color_id
            );
          } else if (product.size_id) {
            return i.size_id == product.size_id && i.color_id == null;
          } else if (product.color_id) {
            return i.color_id == product.color_id && i.size_id == null;
          }
        });

        if (!size_color) {
          const color = product.size_colors?.find(
            (_i) => _i.color_id === product.color_id,
          )?.color;
          const size = product.size_colors?.find(
            (_i) => _i.size_id === product.size_id,
          )?.size;
          Globals.showError(
            `Lo sentimos, el producto ${product?.name} (${[size?.name, color?.name].filter((i) => i != null).join(",")}) no se encuentra en inventario`,
          );
          return false;
        }
      }
    }

    if (this.state.form.payment_type == Constants.PAYMENT_TYPES.TO_PAY) {
      if (this.state.dates.length == 0) {
        Globals.showError("Por favor, seleccione las fechas de los pagos");
        return false;
      }

      if (this.state.form.initial_payment >= this.getTotal()) {
        Globals.showError(
          "El pago inicial no puede ser igual o mayor al monto total. Este es un pedido por cobrar",
        );
        return false;
      }

      if (
        this.state.dates.some(
          (i) =>
            moment(i, "DD-MM-YYYY") >
            moment(this.state.form.payment_date, "DD-MM-YYYY"),
        )
      ) {
        Globals.showError(
          "Lo sentimos, la fecha de pago final no puede ser menor a la fecha de los abonos",
        );
        return false;
      }

      if (!this.state.form.payment_date) {
        Globals.showError("El campo Fecha de pago final es requerido");
        return false;
      }
    }

    if (this.state.form.discount != "" && this.state.form.discount > 100) {
      Globals.showError(
        "El porcentaje de descuento general no puede ser mayor a 100%",
      );
      return false;
    }

    let data = [...this.state.products];
    if (data.length == 0) {
      Globals.showError("Debe ingresar al menos un producto");
      return false;
    }
    if (
      data.some(
        (i) => isNaN(Number(i.purchase_price)) || Number(i.purchase_price) <= 0,
      )
    ) {
      Globals.showError("Debe ingresar el precio de compra de cada producto");
      return false;
    }
    if (data.some((i) => i.quantity == null || i.quantity == "")) {
      Globals.showError("Debe ingresar la cantidad a agregar de cada producto");
      return false;
    }
    if (data.some((i) => i.discount != null && i.discount > 100)) {
      Globals.showError(
        "El porcentaje de descuento de los productos no puede ser mayor a 100%",
      );
      return false;
    }

    if (!this.state.form.provider_id) {
      Globals.showError("El campo Proveedor es requerido");
      return false;
    }

    if (!this.state.form.method_id) {
      Globals.showError("El campo Método de Pago es requerido");
      return false;
    }

    Globals.setLoading();

    // ¿Estamos convirtiendo desde una orden?
    const isConvert = !!(
      this.props.inherit && this.props.inherit.type === "purchase_order"
    );
    const endpoint = this.state.edit
      ? "admin/purchases/edit"
      : isConvert
        ? "admin/purchases/orders/convert-to-purchase"
        : "admin/purchases/create";

    try {
      await axios.post(endpoint, {
        ...this.state.form,
        has_iva: this.state.form.has_iva ? 1 : 0, // enviar el check al backend
        details: JSON.stringify(this.state.products),
        user_id:
          this.props.user.level_id == Constants.ROLE_ADMIN
            ? this.props.user.id
            : this.props.user.admin_id,
        admin_id:
          this.props.user.level_id == Constants.ROLE_ADMIN
            ? this.props.user.id
            : this.props.user.admin_id,
        amount_payment: this.getAmountPayment(),
        payment_date:
          this.state.form.payment_date &&
          moment(this.state.form.payment_date, "DD-MM-YYYY").format(
            "YYYY-MM-DD",
          ),
        dates: JSON.stringify([
          ...this.state.dates.map((i) =>
            moment(i, "DD-MM-YYYY").format("YYYY-MM-DD"),
          ),
        ]),
        purchase_order_id: isConvert
          ? this.props.inherit?.element?.id
          : undefined,
        // normalizamos receiving_date si viene del DatePicker
        receiving_date: this.state.form.receiving_date
          ? moment(this.state.form.receiving_date).format("YYYY-MM-DD")
          : null,
      });

      const actionText = this.state.edit
        ? "editado la compra"
        : isConvert
          ? "convertido la orden de compra en compra"
          : "creado la compra";

      Globals.showSuccess(`Se ha ${actionText} correctamente`);
      this.props.onClose();
    } catch (error) {
      this.enableSubmit();
    } finally {
      Globals.quitLoading();
    }
  };

  close = async () => {
    document.getElementsByClassName("modal").item(0).style.zIndex = 1050;
    await this.setState({modalAddProducts: false, modalCreateProduct: false});
  };

  getProductName = (product) => {
    if (product.type === Constants.PRODUCTS_TYPE.NORMAL) return product.name;

    const size_color = product.size_colors?.find(
      (sc) => sc.id === product.size_color_id,
    );
    let altName = product.name;
    if (!!size_color?.color) altName += `, ${size_color.color.name}`;
    if (!!size_color?.size) altName += `, ${size_color.size.name}`;
    return altName;
  };

  formatStock = (qty, isDecimal) => {
    return isDecimal ? parseFloat(qty).toFixed(2) : parseInt(qty);
  };

  render() {
    const {submitted, products, data, disabled_button} = this.state;

    const amount_payment = this.getAmountPayment();

    return (
      <form onSubmit={this.submit}>
        <div className="container-create-edit-purchase">
          <Modal
            className="modal-product"
            title="Nuevo Producto"
            onClose={this.close}
            visible={this.state.modalCreateProduct}
          >
            <CreateEditProduct
              brands={this.state.brands}
              categories={this.state.categories}
              onClose={this.close}
              user={this.props.user}
            />
          </Modal>

          <Modal
            title="Seleccionar producto"
            onClose={this.close}
            visible={this.state.modalAddProducts}
          >
            <SelectProduct
              onSelect={this.choseProducts}
              onClose={() => this.close()}
            />
          </Modal>

          {this.state.modalAddProducts && (
            <div className="backdrop" onClick={() => this.close()} />
          )}

          <div className="header-grid">
            <Select
              color="gray"
              name="provider_id"
              label="Seleccionar proveedor"
              defaultname="Seleccione"
              className="material"
              labelClass="material"
              disabledFirst={false}
              options={data.providers.map((i) => ({
                value: i.id,
                label:
                  i.company !== null && i.company !== ""
                    ? i.name + " / " + i.company
                    : i.name,
              }))}
              value={this.state.form.provider_id}
              onChange={(e) =>
                this.handleChange({
                  target: {name: e.target.name, value: e.target.value},
                })
              }
            />

            <Select
              color="gray"
              name="method_id"
              label="Método de Pago"
              defaultname="Seleccione"
              className="material"
              labelClass="material"
              disabledFirst={false}
              value={this.state.form.method_id}
              options={data.methods.map((i) => ({value: i.id, label: i.name}))}
              onChange={(e) =>
                this.handleChange({
                  target: {name: e.target.name, value: e.target.value},
                })
              }
            />

            <Input
              color=" "
              name="discount"
              label="Descuento General (%) opcional"
              className="material"
              labelClass="material"
              value={this.state.form.discount}
              onChange={this.handleChange}
            />

            <div className="tab-container">
              <div
                className={`tab ${this.state.form.payment_type === Constants.PAYMENT_TYPES.PAID ? "selected" : ""}`}
                onClick={() =>
                  this.setPaymentType(Constants.PAYMENT_TYPES.PAID)
                }
              >
                Pagada
              </div>
              <div
                className={`tab ${this.state.form.payment_type === Constants.PAYMENT_TYPES.TO_PAY ? "selected" : ""}`}
                onClick={() =>
                  this.setPaymentType(Constants.PAYMENT_TYPES.TO_PAY)
                }
              >
                Por Pagar
              </div>
            </div>

            <Input
              color=" "
              name="comments"
              label="Información adicional (Opcional)"
              className="material"
              labelClass="material"
              value={this.state.form.comments}
              onChange={this.handleChange}
            />

            {/* NUEVOS CAMPOS OPCIONALES */}
            <Input
              color=" "
              name="bill_number"
              label="Número de factura"
              className="material"
              labelClass="material"
              value={this.state.form.bill_number}
              onChange={this.handleChange}
            />

            <Input
              color=" "
              name="person_receiving"
              label="Persona que recibe (Opcional)"
              className="material"
              labelClass="material"
              value={this.state.form.person_receiving}
              onChange={this.handleChange}
            />

            <DatePicker
              color="white"
              label="Fecha de recepción (Opcional)"
              className="material"
              minDate={null}
              value={this.state.form.receiving_date}
              onChange={(v) =>
                this.handleChange({target: {value: v, name: "receiving_date"}})
              }
            />

            {this.state.form.payment_type ===
              Constants.PAYMENT_TYPES.TO_PAY && (
              <>
                <Input
                  color=" "
                  type="number"
                  name="initial_payment"
                  label="Pago inicial (Opcional)"
                  className="material"
                  labelClass="material"
                  value={this.state.form.initial_payment}
                  onChange={this.handleChange}
                />

                <div>
                  <DatePicker
                    color="white"
                    label="Fecha de pago"
                    className="material"
                    minDate={moment().add(1, "day").toDate()}
                    value={""}
                    onChange={(date) => {
                      if (!date) return;
                      const formattedDate = moment(date).format("DD-MM-YYYY");
                      if (this.state.dates.includes(formattedDate)) return;
                      this.toggleDate(formattedDate);
                    }}
                  />

                  <div>
                    {!!this.state.dates.length && (
                      <ul className="dates">
                        {this.state.dates.map((date, index) => (
                          <li
                            key={index}
                            onClick={() => this.toggleDate(date)}
                            title="Click para remover"
                          >
                            {date}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>

                {amount_payment > 0 && (
                  <Input
                    color=" "
                    name="amount_payment"
                    label="Abonos parciales"
                    className="material"
                    labelClass="material"
                    value={Globals.formatMiles(amount_payment)}
                    disabled={true}
                  />
                )}

                <DatePicker
                  color="white"
                  label="Fecha de pago final"
                  className="material"
                  minDate={new Date()}
                  value={this.state.form.payment_date}
                  onChange={(v) =>
                    this.handleChange({
                      target: {value: v, name: "payment_date"},
                    })
                  }
                />
              </>
            )}
          </div>

          <div className="table-actions">
            <Button
              color=" "
              type="button"
              className="secondary"
              outline
              onClick={() => {
                document.getElementsByClassName("modal").item(0).style.zIndex =
                  1040;
                this.setState({modalCreateProduct: true});
              }}
            >
              <span>Crear producto</span>
            </Button>

            <Button
              color=" "
              type="button"
              className="secondary"
              outline
              onClick={() => {
                document.getElementsByClassName("modal").item(0).style.zIndex =
                  1040;
                this.setState({modalAddProducts: true});
              }}
            >
              <span>Agregar producto</span>
            </Button>
          </div>

          <table>
            <thead>
              <tr>
                <th>Cantidad Actual</th>
                <th>Agregar Cantidad</th>
                <th>Producto</th>
                <th>Precio Venta</th>
                <th>Precio Compra</th>
                <th>Descuento</th>
                <th>IVA</th>
                <th>Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product, index) => {
                const showDecimalStock =
                  product?.decimal_stock === Constants.DECIMAL_STOCK.YES;
                const isSizeColor =
                  product?.type == Constants.PRODUCTS_TYPE.SIZE_COLOR;
                let size_color = null;
                let size_color_name = null;
                console.log(`3. RENDER TABLA ITEM ${index}:`, product);
                if (isSizeColor) {
                  size_color = product?.size_colors?.find((i) => {
                    if (product.size_id && product.color_id) {
                      return (
                        i.size_id == product.size_id &&
                        i.color_id == product.color_id
                      );
                    } else if (product.size_id) {
                      return i.size_id == product.size_id && i.color_id == null;
                    } else if (product.color_id) {
                      return (
                        i.color_id == product.color_id && i.size_id == null
                      );
                    }
                  });
                  size_color_name = this.getProductName({
                    ...product,
                    size_color_id: size_color?.id,
                  });
                }

                let stock = isSizeColor
                  ? size_color?.stock || 0
                  : Number(product.stock || 0) -
                    Number(product.reservation || 0);
                // IVA mostrado por línea (si aplica y si has_iva es true)
                let iva = 0;
                if (
                  this.state.form.has_iva &&
                  product.exento === Constants.PRODUCT_EXENTO.NO
                ) {
                  const purchase_price_with_discount = this.getItemSubtotal(
                    product,
                    true,
                  );
                  const rate = this.getIvaPercent(product);
                  iva = (purchase_price_with_discount * rate) / 100;
                }

                return (
                  <tr key={index}>
                    <td>{this.formatStock(stock, showDecimalStock)}</td>
                    <td>
                      <Input
                        color=" "
                        name="quantity"
                        type="number"
                        value={product.quantity}
                        onChange={(e) =>
                          this.changeProduct(e.target.value, "quantity", index)
                        }
                        onBlur={(e) => {
                          if (e.target.value === "") {
                            this.changeProduct("0", "quantity", index);
                          }
                        }}
                      />
                    </td>
                    <td className="product-name">
                      <span className={isSizeColor ? "is-size-color" : ""}>
                        Cod. {product?.code}. {size_color_name || product?.name}
                      </span>
                      {isSizeColor && (
                        <div className="size-color-pop-up">
                          <>
                            {[
                              ...new Set(
                                product?.size_colors
                                  ?.filter((i) => i.color_id)
                                  .map((i) => i.color_id),
                              ),
                            ].length > 0 && (
                              <div className="grid2">
                                <div>Color:</div>
                                <Select
                                  disabledFirst={false}
                                  onChange={async (e) => {
                                    await this.changeValue(
                                      e.target.value,
                                      "color_id",
                                      index,
                                    );
                                    const size_color =
                                      product?.size_colors?.find((i) => {
                                        if (
                                          this.state.products[index].size_id &&
                                          this.state.products[index].color_id
                                        ) {
                                          return (
                                            i.size_id ==
                                              this.state.products[index]
                                                .size_id &&
                                            i.color_id ==
                                              this.state.products[index]
                                                .color_id
                                          );
                                        } else if (
                                          this.state.products[index].size_id
                                        ) {
                                          return (
                                            i.size_id ==
                                              this.state.products[index]
                                                .size_id && i.color_id == null
                                          );
                                        } else if (
                                          this.state.products[index].color_id
                                        ) {
                                          return (
                                            i.color_id ==
                                              this.state.products[index]
                                                .color_id && i.size_id == null
                                          );
                                        }
                                      });
                                    if (size_color) {
                                      await this.changeValue(
                                        size_color?.purchase_price,
                                        "purchase_price",
                                        index,
                                      );
                                      await this.changeValue(
                                        size_color?.sale_price,
                                        "sale_price",
                                        index,
                                      );
                                    }
                                  }}
                                  options={[
                                    ...new Set(
                                      product?.size_colors
                                        ?.filter((i) => i.color_id)
                                        .map((i) => i.color_id),
                                    ),
                                  ].map((_item) => {
                                    const color = product.size_colors?.find(
                                      (i) => i.color_id === _item,
                                    );
                                    return {
                                      value: color?.color?.id,
                                      label: color?.color?.name,
                                    };
                                  })}
                                  value={product.color_id}
                                  className="material"
                                  labelClass="material"
                                  placeholder="Todos"
                                />
                              </div>
                            )}
                            {[
                              ...new Set(
                                product?.size_colors
                                  ?.filter((i) => i.size_id)
                                  .map((i) => i.size_id),
                              ),
                            ].length > 0 && (
                              <div className="grid2">
                                <div>Talla:</div>
                                <Select
                                  disabledFirst={false}
                                  onChange={async (e) => {
                                    await this.changeValue(
                                      e.target.value,
                                      "size_id",
                                      index,
                                    );
                                    const size_color =
                                      product?.size_colors?.find((i) => {
                                        if (
                                          this.state.products[index].size_id &&
                                          this.state.products[index].color_id
                                        ) {
                                          return (
                                            i.size_id ==
                                              this.state.products[index]
                                                .size_id &&
                                            i.color_id ==
                                              this.state.products[index]
                                                .color_id
                                          );
                                        } else if (
                                          this.state.products[index].size_id
                                        ) {
                                          return (
                                            i.size_id ==
                                              this.state.products[index]
                                                .size_id && i.color_id == null
                                          );
                                        } else if (
                                          this.state.products[index].color_id
                                        ) {
                                          return (
                                            i.color_id ==
                                              this.state.products[index]
                                                .color_id && i.size_id == null
                                          );
                                        }
                                      });
                                    if (size_color) {
                                      await this.changeValue(
                                        size_color?.purchase_price,
                                        "purchase_price",
                                        index,
                                      );
                                      await this.changeValue(
                                        size_color?.sale_price,
                                        "sale_price",
                                        index,
                                      );
                                    }
                                  }}
                                  options={[
                                    ...new Set(
                                      product?.size_colors
                                        ?.filter((i) => i.size_id)
                                        .map((i) => i.size_id),
                                    ),
                                  ].map((_item) => {
                                    const size = product.size_colors?.find(
                                      (i) => i.size_id === _item,
                                    );
                                    return {
                                      value: size?.size?.id,
                                      label: size?.size?.name,
                                    };
                                  })}
                                  value={product.size_id}
                                  className="material"
                                  labelClass="material"
                                  placeholder="Todos"
                                />
                              </div>
                            )}
                          </>
                        </div>
                      )}
                    </td>
                    <td>$ {Globals.formatMiles(product?.sale_price)}</td>
                    <td>
                      <Input
                        color=" "
                        name="purchase_price"
                        type="number"
                        value={product.purchase_price}
                        onChange={(e) =>
                          this.changeProduct(
                            e.target.value,
                            "purchase_price",
                            index,
                          )
                        }
                      />
                    </td>
                    <td>
                      <Input
                        color=" "
                        name="discount"
                        placeholder="(Opcional)"
                        className="p-0"
                        type="number"
                        value={product.discount}
                        onChange={(e) =>
                          this.changeProduct(e.target.value, "discount", index)
                        }
                      />
                    </td>
                    <td>$ {Globals.formatMiles(iva)}</td>
                    <td
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "0.5rem",
                      }}
                    >
                      <span>
                        $ {Globals.formatMiles(this.getItemSubtotal(product))}
                      </span>
                      <div>
                        <i
                          className="fa fa-times remove-product"
                          title="Remover producto"
                          onClick={() => this.delete(index)}
                        />
                      </div>
                    </td>
                  </tr>
                );
              })}

              {products.length === 0 && (
                <tr>
                  <td colSpan={8} className="no-items">
                    <div className="no-items">
                      No hay productos en la compra
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Check para decidir si se calcula IVA o no */}
          <div
            style={{display: "flex", justifyContent: "flex-end", marginTop: 10}}
          >
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                cursor: "pointer",
              }}
            >
              <input
                type="checkbox"
                checked={!!this.state.form.has_iva}
                onChange={(e) =>
                  this.handleChange({
                    target: {name: "has_iva", value: e.target.checked},
                  })
                }
              />
              <span>Calcular IVA</span>
            </label>
          </div>

          <div className="total-price blue">
            <div>TOTAL</div>
            <div>$ {Globals.formatMiles(this.getTotal())}</div>
          </div>

          {submitted ? (
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            <div id="button" className="d-flex justify-content-center">
              <Button
                color="green"
                type="button"
                className="primary"
                disabled={disabled_button}
                onClick={() => this.submit()}
              >
                <span>Finalizar</span>
              </Button>
            </div>
          )}
        </div>
      </form>
    );
  }
}

const SelectProduct = ({onSelect, onClose}) => {
  const user = useSelector((state) => state.user);
  const adminId =
    user.level_id === Constants.ROLE_ADMIN ? user.id : user.admin_id;
  const {products, search, isLoading, fetchMore, pagination} =
    useFetch(adminId);

  const [selectedProductId, setSelectedProductId] = useState("");
  const [selectedSizeId, setSelectedSizeId] = useState("");
  const [selectedColorId, setSelectedColorId] = useState("");
  const [selectedPrice, setSelectedPrice] = useState("");
  const [quantity, setQuantity] = useState(1);

  const currentProduct = products.find(
    (p) => String(p.id) === String(selectedProductId),
  );
  const isSizeColor =
    currentProduct?.type === Constants.PRODUCTS_TYPE.SIZE_COLOR;
  const sizeColors = currentProduct?.size_colors || [];

  const availableSizes = [
    ...new Set(sizeColors.filter((sc) => sc.size_id).map((sc) => sc.size_id)),
  ]
    .map((id) => sizeColors.find((sc) => sc.size_id === id)?.size)
    .filter(Boolean);

  const availableColors = [
    ...new Set(sizeColors.filter((sc) => sc.color_id).map((sc) => sc.color_id)),
  ]
    .map((id) => sizeColors.find((sc) => sc.color_id === id)?.color)
    .filter(Boolean);

  useEffect(() => {
    if (!currentProduct) return;

    if (isSizeColor) {
      const match = sizeColors.find((sc) => {
        const matchSize = selectedSizeId
          ? String(sc.size_id) === String(selectedSizeId)
          : true;
        const matchColor = selectedColorId
          ? String(sc.color_id) === String(selectedColorId)
          : true;
        return matchSize && matchColor;
      });

      if (match) {
        setSelectedPrice(match.purchase_price || match.sale_price || 0);
      }
    } else {
      setSelectedPrice(
        currentProduct.purchase_price || currentProduct.sale_price || 0,
      );
    }
  }, [selectedProductId, selectedSizeId, selectedColorId]);

  const handleCargar = () => {
    if (!currentProduct)
      return Globals.showError("Seleccione un producto de la lista");
    if (isSizeColor && availableSizes.length > 0 && !selectedSizeId) {
      return Globals.showError("Seleccione una talla");
    }
    if (isSizeColor && availableColors.length > 0 && !selectedColorId) {
      return Globals.showError("Seleccione un color");
    }

    const itemToAdd = {
      ...currentProduct,
      size_id: selectedSizeId ? Number(selectedSizeId) : null,
      color_id: selectedColorId ? Number(selectedColorId) : null,
      quantity: Number(quantity) || 1,
      purchase_price: Number(selectedPrice) || 0,
    };
    console.log("2. ITEM A AGREGAR:", itemToAdd);

    onSelect([itemToAdd]);
  };

  return (
    <div id="container-create-edit-quote-select-product">
      <Input
        color=" "
        placeholder="Buscar por nombre o código"
        className="material"
        labelClass="material"
        onChange={(e) => search(e.target.value)}
      />

      <div
        className="product-list"
        style={{maxHeight: "220px", overflowY: "auto", margin: "10px 0"}}
      >
        {products.map((item, index) => {
          const isSelected = String(item.id) === String(selectedProductId);
          return (
            <div
              key={`product-item-${index}`}
              className={`product-item ${isSelected ? "selected" : ""}`}
              onClick={() => {
                setSelectedProductId(item.id);
                setSelectedSizeId("");
                setSelectedColorId("");
                setSelectedPrice("");
                setQuantity(1);
              }}
            >
              <div className="product-image">
                <img
                  src={Globals.fromPhotos(item?.photo?.file)}
                  alt="Producto"
                />
              </div>
              <div className="product-details">
                <span
                  className="product-name"
                  style={{fontWeight: "bold", fontSize: "12px"}}
                >
                  Cod. {item?.code}
                </span>
                <span className="product-name">{item?.name}</span>
              </div>
            </div>
          );
        })}
      </div>

      <div className="d-flex justify-content-center my-1">
        {isLoading && <span>Cargando...</span>}
        {!isLoading && pagination.page < pagination.last_page && (
          <Button onClick={() => fetchMore()}>
            <span>Cargar más</span>
          </Button>
        )}
      </div>

      {currentProduct && (
        <div
          className="selected-product-panel p-2 mt-2"
          style={{borderTop: "1px solid #ddd"}}
        >
          <div className="d-flex align-items-center mb-2" style={{gap: "10px"}}>
            <img
              src={Globals.fromPhotos(currentProduct?.photo?.file)}
              alt={currentProduct?.name}
              style={{
                width: "45px",
                height: "45px",
                objectFit: "cover",
                borderRadius: "4px",
              }}
            />
            <div>
              <div style={{fontWeight: "bold"}}>
                Cod. {currentProduct?.code} - {currentProduct?.name}
              </div>
            </div>
          </div>

          {isSizeColor && (
            <div className="grid2 mt-2">
              {availableSizes.length > 0 && (
                <Select
                  label="Talla"
                  defaultname="Seleccione"
                  className="material"
                  labelClass="material"
                  disabledFirst={false}
                  options={availableSizes.map((s) => ({
                    value: s.id,
                    label: s.name,
                  }))}
                  value={selectedSizeId}
                  onChange={(e) => setSelectedSizeId(e.target.value)}
                />
              )}

              {availableColors.length > 0 && (
                <Select
                  label="Color"
                  defaultname="Seleccione"
                  className="material"
                  labelClass="material"
                  disabledFirst={false}
                  options={availableColors.map((c) => ({
                    value: c.id,
                    label: c.name,
                  }))}
                  value={selectedColorId}
                  onChange={(e) => setSelectedColorId(e.target.value)}
                />
              )}
            </div>
          )}

          <div className="grid2 mt-2">
            <Input
              label="Precio Compra"
              type="number"
              className="material"
              labelClass="material"
              value={selectedPrice}
              onChange={(e) => setSelectedPrice(e.target.value)}
            />

            <Input
              label="Cantidad"
              type="number"
              className="material"
              labelClass="material"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
            />
          </div>
        </div>
      )}

      <div className="d-flex justify-content-between mt-3">
        <Button color="blue" type="button" onClick={handleCargar}>
          <span>CARGAR</span>
        </Button>
        <Button color="dark" type="button" onClick={onClose}>
          <span>FINALIZAR</span>
        </Button>
      </div>
    </div>
  );
};

const useFetch = (admin_id) => {
  const initialForm = {
    web: true,
    admin_id,
    search: "",
    page: 1,
    per_page: 20,
    last_page: 1,
    item_count: 0,
  };

  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [pagination, setPagination] = useState(initialForm);

  const debounceTime = 500;
  let debounce = null;

  const fetchData = async () => {
    if (!canFetch) return;

    try {
      const res = await axios.post("web/admin/quotes/products", pagination);
      console.log("API response products:", res.data);
      if (!res?.data?.products)
        return Globals.showError("Ocurrió un error inesperado");

      setCanFetch(false);
      setPagination({
        ...pagination,
        item_count: res?.data?.products?.total,
        last_page: res.data?.products.last_page,
      });

      const newData =
        pagination.page > 1
          ? [...data, ...res.data?.products?.data]
          : res.data?.products?.data;

      setData(newData);
    } catch (error) {
      Globals.showError("Ocurrió un error inesperado");
    }
  };

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setPagination(initialForm);
    fetchData();
  };

  const fetchMore = (page = pagination.page + 1) => {
    if (page >= 1 && page <= pagination.last_page && page !== pagination.page) {
      setCanFetch(true);
      setPagination({...pagination, page});
    }
  };

  const search = (search) => {
    if (debounce) clearTimeout(debounce);
    debounce = setTimeout(() => {
      setCanFetch(true);
      setPagination({...pagination, page: 1, search});
    }, debounceTime);
  };

  useEffect(() => {
    fetchData();
  }, [pagination]);

  return {
    products: data,
    pagination,
    fetchMore,
    reload,
    isLoading: canFetch,
    search,
  };
};

export default connect((state) => {
  return {
    user: state.user,
  };
})(CreateEditPurchase);
